<template>
<div class="fullWidth fRow jBetween aStart wrap">
  <!-- فیلترهای جستجوی آزمون -->
  <div class="fRow jBetween aStart fullWidth wrap fbox">
    <div class="inputHolder fRow jStart aCenter"
      v-bind:class="{w20: examIsSync, w33: !examIsSync}">
      <div class="ih fullWidth fCol jStart aStart">
        <span>انتخاب رشته</span>
        <cool-select
          class="fullWidth"
          @select="selected($event, 'field')"
          v-model="examField"
          disable-search
          :items="fields"
          :item-value="fields.id"
          :item-text="fields.title">
          <!-- slot for each item in the menu -->
          <template slot="item" slot-scope="{ item: field }">
            <div style="display: flex; align-items: center;">
              <div>
                {{ field.title }}
              </div>
            </div>
          </template>
          <!-- slot for the selected item (in the text field) -->
          <template slot="selection" slot-scope="{ item: field }">
            <div>
              {{ field.title }}
            </div>
          </template>
        </cool-select>
      </div>
    </div>
    <div class="inputHolder fRow jStart aCenter"
      v-bind:class="{w20: examIsSync, w33: !examIsSync}">
      <div class="ih fullWidth fCol jStart aStart">
        <span>انتخاب پایه</span>
        <cool-select
          class="fullWidth"
          @select="selected($event, 'grade')"
          v-model="examGrade"
          disable-search
          :items="grades"
          :item-value="grades.id"
          :item-text="grades.title">
          <!-- slot for each item in the menu -->
          <template slot="item" slot-scope="{ item: grade }">
            <div style="display: flex; align-items: center;">
              <div>
                {{ grade.title }}
              </div>
            </div>
          </template>
          <!-- slot for the selected item (in the text field) -->
          <template slot="selection" slot-scope="{ item: grade }">
            <div>
              {{ grade.title }}
            </div>
          </template>
        </cool-select>
      </div>
    </div>
    <div class="inputHolder fRow jStart aCenter"
      v-bind:class="{w20: examIsSync, w33: !examIsSync}">
      <div class="ih fullWidth fCol jStart aStart">
        <span>انتخاب درس</span>
        <cool-select
          class="fullWidth"
          @select="selected($event, 'lesson')"
          v-model="examLesson"
          disable-search
          :items="lessons"
          :item-value="lessons.id"
          :item-text="lessons.title">
          <!-- slot for each item in the menu -->
          <template slot="item" slot-scope="{ item: lesson }">
            <div style="display: flex; align-items: center;">
              <div>
                {{ lesson.title }}
                <b>{{ lesson.value }}</b>
              </div>
            </div>
          </template>
          <!-- slot for the selected item (in the text field) -->
          <template slot="selection" slot-scope="{ item: lesson }">
            <div>
              {{ lesson.title }}
              <b>{{ lesson.value }}</b>
            </div>
          </template>
        </cool-select>
      </div>
    </div>
    <div class="w20 fCol jStart aStart inputHolder"
      v-if="examIsSync">
      <span class="fRow jStart aCenter">
        <i class="material-icons-round"
          v-bind:class="{inpErr: true}">date_range</i>
        شروع بازه</span>
      <div class="fRow jStart aCenter fullWidth inputWraper">
        <input @keyup.enter="newAssignment" id="rangeStart"
          disabled
          class="transition-fast" placeholder="تاریخ آزمون"
          type="text" v-model="rangeStartShow">
      </div>
    </div>
    <date-picker
      format= 'YYYY-MM-DD'
      v-model="rangeStart"
      element="rangeStart"></date-picker>
    <div class="w20 fCol jStart aStart inputHolder"
      v-if="examIsSync">
      <span class="fRow jStart aCenter">
        <i class="material-icons-round"
          v-bind:class="{inpErr: true}">date_range</i>
        پایان بازه</span>
      <div class="fRow jStart aCenter fullWidth inputWraper">
        <input @keyup.enter="newAssignment" id="rangeEnd"
          disabled
          class="transition-fast" placeholder="تاریخ آزمون"
          type="text" v-model="rangeEndShow">
      </div>
    </div>
    <date-picker
      :min="rangeStart"
      format= 'YYYY-MM-DD'
      v-model="rangeEnd"
      element="rangeEnd"></date-picker>
    <div class="w20 fRow jBetween aStart inputHolder"
      @click="examIsSync = !examIsSync"
      style="">
      <span class="fRow jStart aCenter">
        <i class="material-icons-round"
          v-bind:class="{inpErr: true}">sync</i>
        نوع آزمون</span>
      <switch-button
        activeLabel='هماهنگ'
        deactiveLabel='غیرهماهنگ'
        :monocolor="true"
        :val="examIsSync" />
    </div>
    <div class="fRow jStart aCenter">
      <div class="b fRow jStart aCenter"
        @click="getExams"
        v-bind:class="{active: isSearchFormReady}">
        <i class="material-icons-round">search</i>
        <label>جستجو</label>
      </div>
      <div class="b fRow jStart aCenter mini">
        <i class="material-icons-round">delete</i>
        <label>حذف فیلترها</label>
      </div>
    </div>
  </div>
  <div class="fCol jCenter aCenter fullWidth"
    v-if="!loaded">
    <p-bar
      :loading="loading"
      :notYet="notYet"
      :noContent="noContent"
      :notFound="notFound"
      :error="error" />
  </div>
  <div class="fCol jStart aStart fullWidth" v-if="loaded">
    <!-- grid header -->
    <div class='gridHead gridRow fRow jBetween fullWidth'>
      <div class='tableHead index'>ردیف</div>
      <div class='tableHead title big' style="text-align: right;">مشخصات</div>
      <div class='tableHead state'>تاریخ</div>
      <div class='tableHead state'>وضعیت</div>
      <div class='tableHead state'>پاسخ‌نامه</div>
      <div class='tableHead actions big'>عملیات</div>
    </div>
    <exam-row
      v-for="(item, index) in examArray"
      :indx="index + 1"
      v-bind:key="index"
      @refreshExam="getExams"
      :data="item"/>
  </div>
</div>
</template>

<script>
import axios from 'axios';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';
import { CoolSelect } from 'vue-cool-select';
import SwitchButton from '@/components/SwitchButton.vue';
import { EventBus } from '@/plugins/event-bus';
import moment from 'moment-jalaali';
import ExamRow from '@/components/ExamRow.vue';
import 'vue-cool-select/dist/themes/material-design-dark.scss';
import '@/assets/new.scss';
import pBar from './pBar.vue';

export default {
  mixins: [errorHandler, makeToast],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      // modes ↓
      loading: false,
      noContent: false,
      notFound: false,
      error: false,
      notYet: true,
      loaded: false,
      modeMsg: '',
      // modes ↑
      today: '',
      fields: [
        {
          id: 0,
          title: 'متوسطه‌ی اول',
        },
        {
          id: '',
          title: 'حذف فیلتر',
        },
        {
          id: 1,
          title: 'ریاضی',
        },
        {
          id: 2,
          title: 'تجربی',
        },
        {
          id: 3,
          title: 'انسانی',
        },
        {
          id: 4,
          title: 'فنی',
        },
        {
          id: 5,
          title: 'زبان',
        },
        {
          id: 6,
          title: 'هنر',
        },
      ],
      fFieldIdErr: true,
      grades: [
        {
          id: '',
          title: 'لطفا رشته را انتخاب کنید',
        },
      ],
      fGradeErr: true,
      lessons: [
        {
          id: '',
          title: 'ابتدا رشته را انتخاب کنید',
        },
      ],
      fLessonErr: true,
      filterLesson: '',
      // add exam
      examIsSync: false,
      examField: '',
      examGrade: '',
      examLesson: '',
      examDuration: 5,
      examHowManyTimes: 1,
      examIsRandomQuestion: false,
      examSkipOnTime: false,
      examDesc: '',
      eDescLen: 512,
      eDescErr: true,
      examQuestions: [],
      eQuestionIds: [],
      examActiveNumbering: false,
      examArray: [
      ],
      rangeStart: '',
      rangeStartShow: '',
      rangeStartErr: true,
      rangeEnd: '',
      rangeEndShow: '',
      rangeEndErr: true,
      examType: 1,
    };
  },
  components: {
    CoolSelect,
    SwitchButton,
    ExamRow,
    pBar,
  },
  methods: {
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
    clearField() {
      this.examField = '';
      this.fFieldIdErr = true;
    },
    clearGrade() {
      this.examGrade = '';
      this.fGradeErr = true;
      this.grades = {
        id: '',
        title: 'لطفا رشته را انتخاب کنید',
      };
    },
    clearLesson() {
      this.examLesson = '';
      this.fLessonErr = true;
      this.lessons = {
        id: '',
        title: 'لطفا رشته و پایه را انتخاب کنید',
      };
    },
    // dynamic fields
    getFields() {
      this.fields = [
        {
          id: -1,
          title: 'کمی صبر کنید',
        },
      ];
      const reqUrl = `${this.baseURL}/api/v${this.V}/Fields`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        const f = response.data.data;
        if (response.data.isSuccess) {
          if (f.length === 0) {
            this.examGrade = {};
            this.examLesson = {};
            this.grades = [
              {
                id: -1,
                title: 'ابتدا رشته را انتخاب کنید',
              },
            ];
            this.lessons = [
              {
                id: -1,
                title: 'ابتدا رشته را انتخاب کنید',
              },
            ];
            this.fields = [
              {
                id: -1,
                title: 'هیچ رشته‌ای ثبت نشده',
              },
            ];
          } else {
            // this.classGradeErr = true;
            this.examGrade = {};
            // this.classLessonErr = true;
            this.examLesson = {};
            this.fields = [];
            for (let i = 0; i < f.length; i += 1) {
              const item = {
                id: f[i].id,
                title: f[i].title,
              };
              this.fields.push(item);
            }
            // console.log('showExam:', f);
            // خالی نیست
          }
        } else {
          this.makeToast('error', 'خطا در دریافت رشته‌ها', 3000);
          this.fields = [
            {
              id: -1,
              title: 'خطا در دریافت رشته‌ها',
            },
          ];
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.fields = [
          {
            id: -1,
            title: this.errorHandler(error),
          },
        ];
      });
    },
    getGrades(f) {
      let reqUrl = `${this.baseURL}/api/v${this.V}/Grades`;
      if (f !== 0) {
        reqUrl = `${this.baseURL}/api/v${this.V}/Grades?fieldId=${f}`;
      } else {
        return;
      }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.grades = [];
          const arr = response.data.data;
          this.grades.push({
            id: '',
            title: 'حذف فیلتر',
          });
          for (let i = 0; i < arr.length; i += 1) {
            this.grades.push({
              id: arr[i].id,
              title: arr[i].title,
            });
          }
          // console.warn(this.grades);
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    getLessons(f) {
      this.lessons = ['لطفا صبر کنید'];
      let reqUrl = `${this.baseURL}/api/v${this.V}/Lessons`;
      if (f !== 0) {
        reqUrl = `${this.baseURL}/api/v${this.V}/Lessons?gradeId=${f}`;
      }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.lessons = [];
          const arr = response.data.data;
          for (let i = 0; i < arr.length; i += 1) {
            this.lessons.push({
              id: arr[i].id,
              title: arr[i].title,
            });
          }
          // console.warn(this.lessons);
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    selected(e, dropDown) {
      // console.log(e, dropDown);
      switch (dropDown) {
        case 'field': {
          if (e.id !== '' && e.id !== undefined) {
            this.getGrades(e.id);
            this.fFieldIdErr = false;
            this.fGradeErr = true;
            this.fLessonErr = true;
          } else {
            // اگر حذف فیلتر انتخاب شد
            this.clearField();
            this.clearGrade();
            this.clearLesson();
          }
          break;
        }
        case 'grade': {
          if (e.id !== '' && e.id !== undefined) {
            this.getLessons(e.id);
            this.fGradeErr = false;
            this.fLessonErr = true;
          } else {
            // اگر حذف فیلتر انتخاب شد
            this.clearGrade();
            this.clearLesson();
          }
          break;
        }
        case 'lesson': {
          if (e.id !== '' && e.id !== undefined) {
            this.fLessonErr = false;
          } else {
            // اگر حذف فیلتر انتخاب شد
            this.clearLesson();
          }
          break;
        }
        default:
          break;
      }
    },
    clearSelected() {
      this.examQuestions = [];
      EventBus.$emit('clearSelected');
    },
    deleteQuestion(id) {
      if (this.findInArray(id) !== -1) {
        this.examQuestions.splice(this.findInArray(id), 1);
      }
      EventBus.$emit('updateBankSelected', this.examQuestions);
    },
    findInArray(id) {
      let ind = -1;
      for (let i = 0; i < this.examQuestions.length; i += 1) {
        if (this.examQuestions[i].id === id) {
          ind = i;
        }
      }
      return ind;
    },
    calcStart() {
      if (this.rangeStart !== '') {
        this.rangeStartErr = false;
        // eslint-disable-next-line
        this.rangeStartShow = moment(this.rangeStart, 'YYYY-MM-DDT').locale('FA').format('dddd، jDD jMMMM jYYYY');
      } else {
        this.rangeStartErr = false;
      }
    },
    calcEnd() {
      if (this.rangeEnd !== '') {
        this.rangeEndErr = false;
        // eslint-disable-next-line
        this.rangeEndShow = moment(this.rangeEnd, 'YYYY-MM-DDT').locale('FA').format('dddd، jDD jMMMM jYYYY');
      } else {
        this.rangeEndErr = false;
      }
    },
    getExams() {
      if (this.isSearchFormReady) {
        this.setMode('loading');
        const U = this.calculateURL();
        axios({
          method: 'get',
          url: U,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            // console.log(response.data.data);
            this.examArray = response.data.data;
            if (this.examArray.length === 0) {
              this.setMode('noContent');
            } else {
              this.setMode('loaded');
            }
          } else {
            this.responseFalse = true;
            this.makeToast('success', response.data.message, 3000);
            this.setMode('error');
          }
        }, (error) => {
          this.setMode('error', this.errorHandler(error));
          // console.log(error);
        });
      }
    },
    generateQuestions() {
      this.eQuestionIds = [];
      if (this.examQuestions.length > 0) {
        for (let i = 0; i < this.examQuestions.length; i += 1) {
          const t = {
            questionId: this.examQuestions[i].id,
            order: parseInt(document.getElementById(`qIndex${i}`).value, 10),
          };
          this.eQuestionIds.push(t);
        }
      }
      return this.eQuestionIds;
    },
    updateQuestionList(e) {
      this.examQuestions = e;
    },
    calculateURL() {
      let type = 0;
      if (this.examIsSync) {
        type = 1;
      } else {
        type = 2;
      }
      let u = '';
      // چک میکنیم اگه آزمون هماهنگ بود
      if (this.examIsSync) {
        if (!this.fFieldIdErr) {
          // اگه همه گزینه‌ها فعال بودن ↓
          if (!this.fGradeErr && !this.fLessonErr && !this.rangeStartErr && !this.rangeEndErr) {
            // eslint-disable-next-line
            u = `${this.baseURL}/api/v${this.V}/Exams?examType=${type}&startDate=${this.rangeStart}&endDate=${this.rangeEnd}&field=${this.examField.id}&gradeId=${this.examGrade.id}&lessonId=${this.examLesson.id}`;
          }
          // اگه همه گزینه‌ها فعال بودن به جز درس ↓
          if (!this.fGradeErr && this.fLessonErr && !this.rangeStartErr && !this.rangeEndErr) {
            // eslint-disable-next-line
            u = `${this.baseURL}/api/v${this.V}/Exams?examType=${type}&startDate=${this.rangeStart}&endDate=${this.rangeEnd}&field=${this.examField.id}&gradeId=${this.examGrade.id}`;
          }
          // اگه همه گزینه‌ها فعال بودن به جز درس و پایه ↓
          if (this.fGradeErr && this.fLessonErr && !this.rangeStartErr && !this.rangeEndErr) {
            // eslint-disable-next-line
            u = `${this.baseURL}/api/v${this.V}/Exams?examType=${type}&startDate=${this.rangeStart}&endDate=${this.rangeEnd}&field=${this.examField.id}`;
          }
        } else {
          // eslint-disable-next-line
          u = `${this.baseURL}/api/v${this.V}/Exams?examType=${type}&startDate=${this.rangeStart}&endDate=${this.rangeEnd}`;
        }
      } else {
        if (!this.fFieldIdErr) {
          // اگه همه گزینه‌ها فعال بودن ↓
          if (!this.fGradeErr && !this.fLessonErr) {
            // eslint-disable-next-line
            u = `${this.baseURL}/api/v${this.V}/Exams?examType=${type}&field=${this.examField.id}&gradeId=${this.examGrade.id}&lessonId=${this.examLesson.id}`;
          }
          // اگه همه گزینه‌ها فعال بودن جز درس ↓
          if (!this.fGradeErr && this.fLessonErr) {
            // eslint-disable-next-line
            u = `${this.baseURL}/api/v${this.V}/Exams?examType=${type}&field=${this.examField.id}&gradeId=${this.examGrade.id}`;
          }
          // اگه همه گزینه‌ها فعال بودن جز درس و پایه ↓
          if (!this.fGradeErr && this.fLessonErr) {
            // eslint-disable-next-line
            u = `${this.baseURL}/api/v${this.V}/Exams?examType=${type}&field=${this.examField.id}`;
          }
        }
        u = `${this.baseURL}/api/v${this.V}/Exams?examType=${type}`;
      }
      return u;
    },
  },
  computed: {
    isSearchFormReady() {
      let a = false;
      if (this.examIsSync) {
        a = !this.rangeStartErr
          && !this.rangeEndErr;
      } else {
        a = true;
      }
      return a;
    },
  },
  watch: {
    examIsSync() {
      if (this.examIsSync) {
        if (this.examDate === '') {
          this.eDateErr = true;
        } else {
          this.eDateErr = false;
        }
      } else {
        this.examDate = '';
      }
    },
    rangeStart() {
      this.calcStart();
    },
    rangeEnd() {
      this.calcEnd();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getFields();
      this.today = moment(new Date()).format('YYYY-MM-DD');
      EventBus.$on('clearSelected', () => {
      });
      EventBus.$on('updateSelectedClass', (e) => {
        this.examQuestions = e;
      });
      EventBus.$on('editDone', () => {
        this.getExams();
      });
    });
  },
};
</script>

<style lang="scss" scoped>
  .addQuestion {
    padding-left: 16px;
    .disabled {
      cursor: pointer;
      pointer-events: none;
      opacity: 0.25;
    }
    .isTrueCheckBox {
      width: 24px;
      height: 24px;
      color: gray;
      padding: 8px;
      border-radius: 50%;
      margin-left: 8px;
      border: solid 2px gray;
      border-radius: 4px;
      position: relative;
      cursor: pointer;
      * {
        pointer-events: none;
      }
      .tick {
        position: absolute;
        width: 0px;
        top: 8px;
        left: 8px;
        height: 0px;
        border: solid 4px rgb(223, 223, 223);
        border-top: none;
        border-left: none;
        transform: rotate(45deg);
      }
    }
    .isTrueCheckBox:hover {
      border-color: rgb(30, 63, 30);
    }
    .isTrueCheckBox.selected {
      border-color: rgb(30, 63, 30);
      .tick {
        border-color: green;
        width: 12px;
        top: -8px;
        left: 8px;
        height: 24px;
      }
    }
    .noQ {
      height: 112px;
      padding-right: 16px;
      margin-right: 2px;
      border-right: solid 2px rgba($color: #000000, $alpha: 0.15);
      span {
        font-size: 16px;
        font-weight: 100;
        color: gray;
      }
      span.m {
        font-size: 12px;
        font-weight: 300;
        color: gray;
      }
    }
    ul {
      padding: 0;
      margin: 0;
      max-height: 350px;
      border-radius: 8px;
      border: solid 1px rgba($color: #000000, $alpha: 0.05);
      overflow: hidden auto;
      li {
        list-style-type: none;
        padding: 16px;
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.05);
        .qindex {
          width: 24px;
          min-width: 24px;
          font-size: 10px;
          font-weight: 300;
          text-align: right;
        }
        .qQuestion {
          span.q {
            font-size: 13px;
            font-weight: bold;
            text-align: right;
          }
          i {
            margin-left: 8px;
            opacity: 0.5;
            transition: all ease-in-out 0.3s;
          }
          i:hover {
            opacity: 1;
          }
          i.hard {
            color: rgb(206, 0, 0);
          }
          i.normal {
            color: rgb(27, 190, 49);
          }
          i.easy {
            color: rgb(54, 101, 161);
          }
          .qOptions {
            p {
              font-size: 12px;
              text-align: right;
              margin-top: 8px;
              font-weight: bold;
            }
          }
        }
        @keyframes inp {
          0% {
            box-shadow: 0 0 0 0 rgba($color: #000000, $alpha: 0.25);
          }
          100% {
            box-shadow: 0 0 0 16px rgba($color: #000000, $alpha: 0.0);
          }
        }
        input[type='number'] {
          width: 32px;
          text-align: center;
          border-radius: 8px;
          border: solid 2px rgba($color: #000000, $alpha: 0.1);
          animation: inp 2s cubic-bezier(1, 0, 0, 1) infinite;
          margin-left: 8px;
        }
        input[type='number']:disabled {
          width: 32px;
          text-align: center;
          border-radius: 8px;
          border: solid 2px rgba($color: #000000, $alpha: 0.0);
          animation: none;
          margin-left: 8px;
        }
      }
      li.selected {
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
      li:hover {
        background-color: rgba($color: #000000, $alpha: 0.02);
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.0);
      }
    }
  }
</style>
